<template>
    <v-container>
        <p class="text-h4 ml-3 font-weight-bold black--text" style="margin-top: 4% !important">Your Cart</p>
        <v-row class="mt-3 pl-2" v-if="this.$store.getters.cart.length > 0">
            <v-col cols="12" sm="8">
                <v-list>
                    <template v-for="(item, index) in order.items">
                        <v-list-item :key="item._id">
                            <cart-item :item="item" @delete="removeItem"></cart-item>
                        </v-list-item>
                        <v-divider :key="index"></v-divider>
                    </template>
                </v-list>
            </v-col>
            <v-col cols="12" sm="4">
                <cart-order-details :order="order"></cart-order-details>
            </v-col>
        </v-row>
        <empty-cart v-else></empty-cart>
    </v-container>
</template>

<script>
import CartItem from '../../components/CartItem.vue'
import CartOrderDetails from '../../components/CartOrderDetails.vue'
import EmptyCart from '../../components/EmptyCart.vue'

export default {
    components: { EmptyCart, CartItem, CartOrderDetails },
    data() {
        return {
            order: this.defaultOrder()
        }
    },
    mounted() {
        this.initializeCart();
    },
    methods: {
        initializeCart() {
            var cartItems = this.$store.getters.cart
            if (cartItems.length) {
                this.order.items = cartItems.map(cartItem => this.convertProductToOrderItem(cartItem, cartItem.quantity))
                this.$store.commit('updateOrder', this.order)
            }
        },

        removeItem(product) {
            this.initializeCart()
            
        },
        defaultOrder() {
            return {
                paymentType: '',
                items: [],
                pStatus: undefined,
                tax: 0,
                total: 200,
                taxAmount: 0,
                discount: {
                    amount: 0,
                    type: '',
                    percent: 0,
                    code: ''
                },
                subTotal: 150,
                delivery: {
                    date: ''
                },
                customer: {
                    _id: '',
                    displayName: "",
                    firstName: "",
                    lastName: "",
                    mobileNo: "",
                    email: '',
                    address: '',
                    deleteAddress: []
                },
                channel: "WEBSTORE",
                delivery: {
                    type: '',
                    address: '',
                    charge: 0
                },
                redeemedReward: 0,
            }
        }
    },
}
</script>

<style lang="scss" scoped></style>